const COLORS = {
  BLACK: "#000000",
  DARK_GRAY: "#303030",
  WHITE: "#FFFFFF",
};

export { COLORS };
